/**
 * useAnalytics Hook
 * React hook for easy analytics integration
 */

import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../services/analyticsService';

export const useAnalytics = () => {
  const location = useLocation();

  // Track page views on route change
  useEffect(() => {
    analyticsService.trackPageView(location.pathname, document.title);
  }, [location]);

  // Track custom event
  const trackEvent = useCallback((eventName, parameters) => {
    analyticsService.trackEvent(eventName, parameters);
  }, []);

  // Track visualiser events
  const trackVisualiserStart = useCallback((source = 'unknown') => {
    analyticsService.trackVisualiserEvent('start', {
      source,
      device_type: window.innerWidth < 992 ? 'mobile' : 'desktop',
    });
  }, []);

  const trackVisualiserSave = useCallback((configuration) => {
    analyticsService.trackVisualiserEvent('save', configuration);
  }, []);

  const trackVisualiserQuote = useCallback((configuration) => {
    analyticsService.trackVisualiserEvent('quote', configuration);
  }, []);

  // Track form submissions
  const trackFormSubmit = useCallback((formName, formData) => {
    analyticsService.trackFormSubmit(formName, formData);
  }, []);

  // Track errors
  const trackError = useCallback((errorType, errorMessage, additionalData) => {
    analyticsService.trackError(errorType, errorMessage, additionalData);
  }, []);

  // Get debug info
  const getDebugInfo = useCallback(() => {
    return analyticsService.getDebugInfo();
  }, []);

  return {
    trackEvent,
    trackVisualiserStart,
    trackVisualiserSave,
    trackVisualiserQuote,
    trackFormSubmit,
    trackError,
    getDebugInfo,
  };
};

export default useAnalytics;